import {reactive} from "vue";

type DateString = string;

export type ParticipationStatus = "NotAnswered" | "Refused" | "Participates" | "Paid"

export type PaymentType = "Manual" | "PerRepeat";
export type SponsorType = "Private" | "Company";
export type BillingMethod = "Mail" | "Email";

export interface Identity {
    deviceId: string;
    accessToken: string;
}

export interface Area {
    name: string;
}

export interface Attachment {
    attachmentId: number;
    displayName: string;
    path: string;
}

export interface Organization {
    organizationId: number;
    name: string;
    area: Area;
    totalSponsorshipAmount: number;
}

export interface User {
    userId: number;
    firstName: string;
    lastName: string;
    fullName: string;
    organizations: Organization[];
    slogan: string;
    profilePicture: Attachment;
    locale: string;
    selectedOrganizationId?: number;
    selectedEventId?: number;
}

export interface Sponsor {
    sponsorId: number;
    sponsorType: SponsorType;
    firstname: string;
    lastname: string;
    fullName: string;
    companyName: string;
    email: string;
    payment: number;
    paymentMethod: PaymentType;
    billSentOn?: Date;
    invitedOn?: Date;
    notificationSentOn?: Date;
    numNotificationsSent: number;
    participationStatus: ParticipationStatus;
    estimatedPayment: number;
    shouldPay: number;
    paid: number;
    eventParticipantId: number;
    info: string;

    preferredBillingMethod: BillingMethod;

    streetAddress: string;
    zipCode: string;
    city: string;

    sendingEmail: boolean;
    editingEmail: boolean;
}

export interface Event {
    eventId: number;
    eventDate?: DateString;
    organizationId: number;
    name: string;
    sponsors: Sponsor[];
    eventParticipant: EventParticipant;
}

export interface EventParticipant {
    eventParticipantId: number;
    userId: number;
    eventId: number;
    estimatedRepeats?: number;
    repeats?: number;
    suggestedPaymentPerRepeat?: number;
    repeatsLocked: boolean;
    canSendBill: boolean;
}

export interface UserSponsorship {
    user: User;
    totalSponsorshipAmount: number;
}

export interface Sponsorship {
    userId: number;
    name: string;
    amount: number;
}

export interface Page {
    title: string;
    showTopNav: boolean;
}

export interface Popup {
    title: string;
    description: string;
    visible: boolean;
}

export interface GlobalSettings {
    permissionText: string;
    mobileInstructions: string;
    paymentMinPerRepeat: number;
    paymentMinManual: number;
    publicRulesDescription: string;
    mobilePrivacyInfo: string;
}

export interface State {
    identity: Identity;
    currentUser: User;
    events: Event[];
    selectedOrganization: Organization;
    selectedEvent: Event;
    page: Page;
    popup: Popup;
    globalSettings: GlobalSettings;
}


const defaultState: State = {
    identity: null,
    currentUser: null,
    events: [],
    selectedOrganization: null,
    selectedEvent: null,
    page: {title: "", showTopNav: true},
    popup: {title: "", description: "", visible: false},
    globalSettings: {
        permissionText: "",
        mobileInstructions: "",
        paymentMinPerRepeat: 0,
        paymentMinManual: 0,
        publicRulesDescription: "",
        mobilePrivacyInfo: "",
    },
};

export const store = reactive(defaultState);

export default store;
